// src/services/settingsService.js
import { api } from './api';

export const settingsService = {
  // Office Location Settings
  getOfficeSettings: () => 
    api.get('/api/settings/office'),
    
  saveOfficeSettings: (data) => 
    api.post('/api/settings/office', data),

  // IP Whitelisting Settings
  getIPSettings: () => 
    api.get('/api/ip-settings/'),
    
  saveIPSettings: (data) => 
    api.post('/api/ip-settings/', data),

  // Work Schedules (Settings)
  getSchedules: () => 
    api.get('/api/schedules/'),
    
  createSchedule: (data) => 
    api.post('/api/schedules/', data),
    
  updateSchedule: (id, data) => 
    api.put('/api/schedules/' + id, data),
    
  deleteSchedule: (id) => 
    api.delete('/api/schedules/' + id)
};